module.exports = __webpack_public_path__ + "src/assets/img/smoke_one.a77dd51d.svg";